<template>
    <UploadInput
        :existing-attachments="attachments"
        :can-download="attrs.canDownload"
        @download="attrs.download"
        @upload-finished="(index, filename, upload) => attrs.uploadFinished(upload)"
        @upload-removed="attrs.uploadRemoved"
    />
</template>
<script lang="ts" setup>
    import type {PropType} from 'vue';
    import UploadInput from '~/composables/uploads/UploadInput.vue';
    import type {ClaimedUpload, UploadConfig} from '~/lib/types/uploads';

    defineProps({
        attachments: {
            type: Array as PropType<ClaimedUpload[]>,
            required: true
        },
        attrs: {
            type: Object as PropType<UploadConfig>,
            default: () => ({})
        }
    });
</script>
